import PageWrapper from 'enrollment-platform/PageWrapper'
import useFeatureFlags from 'hooks/useFeatureFlags'
import React, { useEffect } from 'react'
import { browserHistory } from 'react-router'

/**
 * Route wrapper for the entire DemoCompanyManagement section.
 *
 * When `admin.customers.demo-management-enabled` is off, every URL under
 * /demo-company-management redirects to Home rather than rendering. This
 * single gate replaces the per-page flag checks that each child page
 * previously had to duplicate.
 *
 * The same flag hides the sidebar tab in useNavigationLinks, so the link and
 * the routes turn on together. Role gating is separate and lives in
 * DemoCompanyManagement.route.ts, which admits platform admins only.
 */
export default function DemoCompanyGate({
  children,
}: {
  children: React.ReactNode
}) {
  const { flags } = useFeatureFlags()
  const flagEnabled = flags['admin.customers.demo-management-enabled']

  useEffect(() => {
    if (flagEnabled === false) {
      browserHistory.replace('/')
    }
  }, [flagEnabled])

  // While LaunchDarkly is still initialising flagEnabled is undefined —
  // render null (don't flash content) rather than redirecting prematurely.
  if (!flagEnabled) return null

  return <PageWrapper>{children}</PageWrapper>
}
